<template>
  <div
    class="bg-opacity-30 left-0 top-0 transition-all"
    :class="{
      'bg-black fixed h-screen w-screen z-50 xl:bg-transparent xl:w-0 xl:h-0':
        isActive,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
    },
  },
}
</script>
